module.exports = __webpack_public_path__ + "static/media/qr.f3a5bbd6.jpg";